'use strict';

var slickConfigs = require('./slickConfig');
var utils = require('../utils');

function setProperties() {
    let root = document.documentElement;
    var headerHeight = $('header').outerHeight();
    var bannerHeight = $('.header-banner').outerHeight();
    var headerNavigationHeight = $('.header-navigation').outerHeight();

    root.style.setProperty('--header-height', `${headerHeight}px`);
    root.style.setProperty('--promo-height', `${bannerHeight}px`);
    root.style.setProperty('--search-panel-top', `${headerNavigationHeight}px`);

    try {
        var prevExpandedHeaderHeight = root.style.getPropertyValue('--expanded-header-height');

        if (Number(prevExpandedHeaderHeight.slice(0, -2)) !== headerHeight) {
            root.style.setProperty('--expanded-header-height', `${headerHeight}px`);
        }
    } catch (e) {
        root.style.setProperty('--expanded-header-height', `${headerHeight}px`);
    }
}

function isSearchPanelOpen() {
    return $('#SearchPanel').hasClass('show');
}

const collapsibleHeader = {
    element: $('header'),
    collapsibleElements: function () {
        var isMobileViewport = $(window).outerWidth() < utils.breakpoints.md;
        if (isMobileViewport) {
            return $('.main-menu .navbar.slide-up, .search-result-header.slide-up');
        }
        return $('.header-banner.slide-up, .main-menu .navbar.slide-up, .search-result-header.slide-up');
    },
    expandedHeight: $('header').outerHeight(),
    isCollapsed: function () {
        var collapsibleElements = this.collapsibleElements().toArray().map(el => $(el).hasClass('hide'));
        if (collapsibleElements.length) {
            return collapsibleElements.reduce((foo, bar) => foo && bar);
        }
        return false;
    },
    getHeight: function () {
        var collapsibleElementsHeight = 0;
        if (this.collapsibleElements().length) {
            collapsibleElementsHeight += this.collapsibleElements().toArray().map(el => $(el).hasClass('hide') ? $(el).outerHeight() : 0).reduce((foo, bar) => foo + bar);
        }
        return this.element.outerHeight() - collapsibleElementsHeight;
    },
    lockExpand: function (duration) {
        window.isExpandLocked = true;
        if (duration) {
            setTimeout(function () {
                window.isExpandLocked = false;
            }, duration);
        }
    },
    unlockExpand: function () {
        window.isExpandLocked = false;
    },
    collapse: function () {
        $(document).trigger('beforeCollapseHeader');
        this.collapsibleElements().addClass('hide');
        $('.pinup-section').addClass('sticky');
        $('.sticky-refinement').addClass('collapsed-header');
        $('.navbar-header').addClass('filter-sort-sticky');
        $('.header-navigation').addClass('collapsed');
        $('html').addClass('header-collapsed');
        $('.right-section-header, .sort-filter-wrapper').css('top', parseInt(this.getHeight(), 10) + 'px');
        // move focus to after nav if focus was inside on collapse
        var $mainMenu = this.element.find('.main-menu');
        if ($mainMenu.length) {
            if ($mainMenu[0].contains(document.activeElement)) {
                this.element.next().find('a:visible,button:visible,input:visible,[tabindex="0"]:visible').eq(0).focus();
            }
            setTimeout(function () {
                $(document).trigger('afterCollapseHeader');
            }, 500);
        }
        setProperties();
    },
    expand: function () {
        if (window.isExpandLocked) return;
        $(document).trigger('beforeExpandHeader');
        if (window.isAutoScrolledFlag) {
            this.collapsibleElements().removeClass('hide');
        }
        $('.pinup-section').removeClass('sticky');
        $('.sticky-refinement').removeClass('collapsed-header');
        $('.navbar-header').addClass('filter-sort-sticky');
        $('.header-navigation').removeClass('collapsed');
        $('.right-section-header').removeClass('is-sticky');
        $('html').removeClass('header-collapsed');
        if (window.isAutoScrolledFlag) {
            $('.right-section-header, .sort-filter-wrapper').css('top', parseInt(this.getHeight(), 10) + 'px');
        } else {
            $('.right-section-header, .sort-filter-wrapper').css('top', parseInt(this.getHeight(), 10) + 'px');
        }
        setTimeout(function () {
            $(document).trigger('afterExpandHeader');
        }, 500);
        setProperties();
    },
    toggle: function () {
        if (this.isCollapsed()) {
            this.expand();
        } else {
            this.collapse();
        }
    },
    eventListeners: function () {
        var self = this;
        $(document).on('collapseHeader', () => self.collapse());
        $(document).on('expandHeader', () => self.expand());
    }
};

const searchToggle = function () {
    $(document)
        .on('click keydown', function (e) {
            if (isSearchPanelOpen() && ((e.type === 'click' && !$(e.target).closest('#SearchPanel').length) || e.keyCode === 27)) { // Escape
                $('#SearchPanel').collapse('hide');
            }
        })
        .on('keydown', '.search-toggler', function (e) {
            if (e.which === 13 || e.which === 32) {
                e.preventDefault();
                $('#SearchPanel').collapse('toggle');
            }
        })
        .on('show.bs.collapse', '#SearchPanel', function () {
            $(document).trigger('custom:collapse:mega:menu');
            if ($('.collapse-left').hasClass('show')) {
                $('.collapse-left').find('.close:first').click();
            }
            $('.sticky-refinement').addClass('hide-z-index');
            $('.modal-background').show();
            $('input.search-field').val('');
            setProperties();
        })
        .on('shown.bs.collapse', '#SearchPanel', function () {
            var $panel = $('#SearchPanel');
            // Focus the search field only after dialog is fully shown
            var $searchField = $panel.find('.search-field:visible').first();
            if ($searchField.length) {
                $searchField.focus();
            }
            // Setup focus trap
            $panel.on('keydown.focusTrap', function (e) {
                var $focusable = $panel
                    .find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])')
                    .filter(':visible');
                if (!$focusable.length) return;
                var first = $focusable.first();
                var last = $focusable.last();

                if (e.key === 'Tab') {
                    if (e.shiftKey && document.activeElement === first[0]) {
                        e.preventDefault();
                        last.focus();
                    } else if (!e.shiftKey && document.activeElement === last[0]) {
                        e.preventDefault();
                        first.focus();
                    }
                } else if (e.key === 'Escape') {
                    $('#SearchPanel').collapse('hide');
                }
            });
        })
        .on('hide.bs.collapse', '#SearchPanel', function () {
            // Hide the search toggler from screen readers BEFORE Bootstrap updates aria-expanded
            var searchToggler = document.querySelector('.header-right-part .search.hidden-sm-down .search-toggler');
            if (searchToggler) {
                searchToggler.setAttribute('aria-hidden', 'true');
            }
        })
        .on('hidden.bs.collapse', '#SearchPanel', function () {
            $('.sticky-refinement').removeClass('hide-z-index');
            $('.modal-background').hide();
            $('#SearchPanel').off('keydown.focusTrap');
            // Clear search without triggering click event
            $('.reset-button').removeClass('d-block');
            $('.popular-new-search-wrapper').removeClass('d-none');
            $('.suggestions-wrapper').empty();
            $('input.search-field').val('');
            // Use inert to hide ALL header elements except the search toggler during focus transition
            var headerElementsToHide = document.querySelectorAll(
                '.header-left-collapsed, .header-left-part, .brand, .header-right-part .user, .header-right-part .minicart, .main-menu'
            );
            headerElementsToHide.forEach(function (el) {
                el.setAttribute('inert', '');
            });
            // Return focus to the search toggler
            setTimeout(function () {
                var searchToggler = document.querySelector('.header-right-part .search.hidden-sm-down .search-toggler');
                if (searchToggler) {
                    // Remove aria-hidden and set focus
                    searchToggler.removeAttribute('aria-hidden');
                    searchToggler.focus();
                }
                // Remove inert after focus is set
                setTimeout(function () {
                    headerElementsToHide.forEach(function (el) {
                        el.removeAttribute('inert');
                    });
                }, 150);
            }, 100);
        });
};

const userToggle = function () {
    // Two-step focus: briefly focus the ul[role="menu"] so NVDA detects the ARIA role and
    // switches to application mode, then move focus to the first item. Without this, NVDA
    // stays in browse mode after the menu opens and requires a second ESC press to close.
    function focusMenuContent($menu) {
        $menu.attr('tabindex', '-1').focus();
        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                var firstItem = $menu.find('a:first')[0];
                if (firstItem) {
                    firstItem.focus();
                }
            });
        });
    }

    // Toggle menu on click
    // Delegated on document since the account menu markup is replaced later via AJAX (loadAccountHeaderMenu)
    $(document).on('click', '.user .toggle-menu', function (e) {
        e.preventDefault();
        var $menu = $(this).siblings('.user-dropdown-menu');
        var isExpanded = $menu.hasClass('user-dropdown-menu-show');

        // Close all menus first
        $('.user-dropdown-menu').removeClass('user-dropdown-menu-show logged-user-menu').attr('aria-hidden', 'true');
        $('.toggle-menu').attr('aria-expanded', 'false');

        if (!isExpanded) {
            $menu.addClass('user-dropdown-menu-show logged-user-menu').attr('aria-hidden', 'false');
            $(this).attr('aria-expanded', 'true');
            focusMenuContent($menu);
        }
    });

    // Handle keyboard activation (Enter and Space)
    $(document).on('keydown', '.user .toggle-menu', function (e) {
        if (e.which === 13 || e.which === 32) { // Enter or Space
            e.preventDefault();
            e.stopPropagation();
            var $toggle = $(this);
            var $menu = $toggle.siblings('.user-dropdown-menu');
            var isExpanded = $menu.hasClass('user-dropdown-menu-show');

            $toggle.trigger('click');

            if (!isExpanded) {
                // Wait for CSS transition, then apply two-step focus
                var doFocus = function () {
                    $menu.off('transitionend', doFocus);
                    focusMenuContent($menu);
                };
                $menu.on('transitionend', doFocus);
                // Fallback in case transitionend doesn't fire
                setTimeout(function () {
                    $menu.off('transitionend', doFocus);
                    if (!$menu[0].contains(document.activeElement)) {
                        focusMenuContent($menu);
                    }
                }, 300);
            }
        }
    });

    // Handle focus trapping within the menu for keyboard navigation
    $(document).on('keydown', '.user-dropdown-menu', function (e) {
        var $menu = $(this);

        // Only trap focus if menu is explicitly opened
        if (!$menu.hasClass('user-dropdown-menu-show')) {
            return;
        }

        // Handle Tab key for focus trapping
        if (e.which === 9) { // Tab key
            var $menuItems = $menu.find('a[href]:visible');
            var $firstMenuItem = $menuItems.first();
            var $lastMenuItem = $menuItems.last();

            // If shift+tab on first menu item, go to last menu item
            if (e.shiftKey && document.activeElement === $firstMenuItem[0]) {
                e.preventDefault();
                $lastMenuItem[0].focus();
            } else if (!e.shiftKey && document.activeElement === $lastMenuItem[0]) {
                // If tab on last menu item, go to first menu item
                e.preventDefault();
                $firstMenuItem[0].focus();
            }
        } else if (e.which === 27) { // Escape key — handle directly on menu so NVDA application mode catches it on first press
            e.preventDefault();
            e.stopPropagation();
            $menu.removeClass('user-dropdown-menu-show logged-user-menu').attr('aria-hidden', 'true');
            $('.toggle-menu').attr('aria-expanded', 'false');
            $('.user .toggle-menu').focus();
        }
    });

    // Update aria-expanded on mouse hover (for screen readers)
    $(document).on('mouseenter', '.user li', function () {
        $(this).find('.toggle-menu').attr('aria-expanded', 'true');
    });

    $(document).on('mouseleave', '.user li', function () {
        var $menu = $(this).find('.user-dropdown-menu');
        // Only set to false if not explicitly opened via click
        if (!$menu.hasClass('user-dropdown-menu-show')) {
            $(this).find('.toggle-menu').attr('aria-expanded', 'false');
        }
    });

    // Close menu when clicking outside
    $(document).on('click', function (e) {
        if (!$(e.target).closest('.user').length) {
            $('.user-dropdown-menu').removeClass('user-dropdown-menu-show logged-user-menu').attr('aria-hidden', 'true');
            $('.toggle-menu').attr('aria-expanded', 'false');
        }
    });

    // Close menu on Escape key
    $(document).on('keydown', function (e) {
        if (e.which === 27) { // Escape
            var $menu = $('.user-dropdown-menu.user-dropdown-menu-show');
            if ($menu.length) {
                $menu.removeClass('user-dropdown-menu-show logged-user-menu').attr('aria-hidden', 'true');
                $('.toggle-menu').attr('aria-expanded', 'false');
                // Return focus to toggle button when closing with Escape
                $('.user .toggle-menu').focus();
            }
        }
    });

    // Handle focus within menu for mouse users
    $(document).on('focusout', '.user', function () {
        var $user = $(this);
        var $menu = $user.find('.user-dropdown-menu');

        // Only close on focusout if menu was NOT explicitly opened via click
        if (!$menu.hasClass('user-dropdown-menu-show')) {
            // Use setTimeout to allow the browser to update document.activeElement
            setTimeout(function () {
                if (!$user[0].contains(document.activeElement)) {
                    $user.find('.user-dropdown-menu').removeClass('user-dropdown-menu-show logged-user-menu');
                    $user.find('.toggle-menu').attr('aria-expanded', 'false');
                }
            }, 0);
        }
    });
};

function setTopSpace() {
    var headerBannerRender = setInterval(function () {
        if ($('.header-banner').find('.header-banner-promo').hasClass('slick-initialized')) {
            var headerPromoHeight = $('.header-banner').find('.header-banner-content').outerHeight();
            $('.header-banner').attr('bannerHeight', headerPromoHeight);

            clearInterval(headerBannerRender);
        }
    }, 250);
}

function getRoundedNamber(source) {
    try {
        return Math.round(source * 1000) / 1000;
    } catch (e) {
        return 0;
    }
}

const init = function () {
    window.history.scrollRestoration = 'manual';
    window.isAutoScrolledFlag = true;
    this.collapsibleHeader.eventListeners();

    // MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(function () {
        var $mobileRefinementBar = $('#mobileRefinementBar');

        if (!$mobileRefinementBar.length) {
            return;
        }

        var $refinementsSidebar = $('.refinements-sidebar');
        var $refinementsSlide = $refinementsSidebar.find('.refinements-slide');
        var $mobRefinementContainer = $mobileRefinementBar.find('.mob-refinement-container');
        var headerHeight = getRoundedNamber($('header').outerHeight());
        var filterNavHeight = getRoundedNamber($('.filter-nav-wrapper').outerHeight());
        var totalStickyHeight = headerHeight + filterNavHeight + 10;

        if ($refinementsSlide.css('top') !== (totalStickyHeight + 'px')) {
            $refinementsSlide.css('top', totalStickyHeight);
        }

        if ($(window).outerWidth() < utils.breakpoints.md) {
            var mobFilterContent = getRoundedNamber($mobileRefinementBar.find('.filter-mob-height').outerHeight());
            var stickyClearApplyBtn = getRoundedNamber($mobileRefinementBar.find('.mobile-refinement-bar').outerHeight());
            var totalMaxHeight = headerHeight + mobFilterContent + stickyClearApplyBtn;
            var mobRefinementContainerHeight = getRoundedNamber($(window).height() - totalMaxHeight - 5);

            if ($mobRefinementContainer.css('height') !== (mobRefinementContainerHeight + 'px')) {
                $mobRefinementContainer.css('height', mobRefinementContainerHeight);
            }
        }

        var isMobileRefinementBarShow = $mobileRefinementBar.hasClass('show');
        var isRefinementsSidebarNonAnimating = !$('.refinements-sidebar').hasClass('animate');
        $('body').toggleClass('filter-panel-is-open', isMobileRefinementBarShow || isRefinementsSidebarNonAnimating);
    });

    observer.observe(document, {
        subtree: true,
        attributes: true
    });

    $(document).ready(function () {
        $('.slick-carousel-promo').not('.slick-initialized').slick(slickConfigs.pdPromoBanner);
        $('.global-promo-banner').removeClass('hidden');

        $('.slick-carousel-promo').on('beforeChange', function (event, slick, currentSlide) {
            slick.$slides.eq(currentSlide)
            .find('a, button, [tabindex]')
            .attr('tabindex', '-1');
        });

        $('.slick-carousel-promo').on('afterChange', function (event, slick, currentSlide) {
            slick.$slides.eq(currentSlide)
            .find('a, button, [tabindex]')
            .removeAttr('tabindex');
        });
    });
};

$(window).on('load', function () {
    setProperties();
    setTopSpace();
});

utils.smartResize(function () {
    setProperties();
    setTopSpace();
});

utils.smartScroll(function () {
    setProperties();
});

$(document).on('click', '.js_country-selector-popup', function (e) {
    const $modal = $('#countryselector-popup');

    if ($modal.length) {
        e.preventDefault();
        $(document).trigger('custom:collapse:mega:menu');
        $modal.data('opener', this);
        $modal.modal('show');
    }
});

/** Global-E Selector set opener */
$(document).on('click', '.globale-selector button', function (e) {
    const $modal = $('#globalePopupWrapper');

    if ($modal.length) {
        e.preventDefault();
        $(document).trigger('custom:collapse:mega:menu');
        $modal.data('opener', this);
        $modal.trigger('show.bs.modal');
    }
});

// Handle close button click to prevent default behavior and just trigger modal hide
$(document).on('click', '#countryselector-popup .close, #globalePopupWrapper .glClose', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('#countryselector-popup').modal('hide');
    // Isolate Global-e logic
    if (this.className === 'glClose') {
        $('#globalePopupWrapper').trigger('hidden.bs.modal');
    }
});

// Handle escape key to close modal
$(document).on('keydown', '#countryselector-popup, #globalePopupWrapper', function (e) {
    if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        $(this).modal('hide');
        // Isolate Global-e logic
        if (this.id === 'globalePopupWrapper') {
            $('#globalePopupWrapper').trigger('hidden.bs.modal');
        }
    }
});

// Handle focus management for country selector modal
$(document).on('show.bs.modal', '#countryselector-popup, #globalePopupWrapper', function () {
    var opener = $(this).data('opener');
    var $modal = $(this);

    if (opener) {
        // Store the current scroll position
        $(this).data('scrollTop', $(window).scrollTop());
    }

    // Ensure modal has proper ARIA attributes for screen readers
    $modal.attr({
        role: 'dialog',
        'aria-modal': 'true',
        'aria-hidden': 'false'
    });
});

// Prevent modal container from receiving focus during keyboard navigation
$(document).on('shown.bs.modal', '#countryselector-popup, #globalePopupWrapper', function () {
    var $modal = $(this);

    // Remove tabindex to prevent modal container from being focusable
    $modal.attr('tabindex', '-1').css('outline', 'none');

    // Trap focus within focusable children only
    var $focusableElements = $modal.find('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');

    if ($focusableElements.length === 0) {
        return;
    }

    var $firstFocusable = $focusableElements.first();
    var $lastFocusable = $focusableElements.last();

    // Focus first focusable element
    setTimeout(function () {
        $firstFocusable.focus();
    }, 100);

    // Handle tab key to keep focus within modal children
    $modal.off('keydown.modal-focus').on('keydown.modal-focus', function (e) {
        if (e.key !== 'Tab') {
            return;
        }

        // Prevent focus from going to modal container
        if (e.target === $modal[0]) {
            e.preventDefault();
            if (e.shiftKey) {
                $lastFocusable.focus();
            } else {
                $firstFocusable.focus();
            }
            return;
        }

        if (e.shiftKey) {
            // Shift + Tab
            if (document.activeElement === $firstFocusable[0]) {
                e.preventDefault();
                $lastFocusable.focus();
            }
        } else if (document.activeElement === $lastFocusable[0]) {
            // Tab
            e.preventDefault();
            $firstFocusable.focus();
        }
    });
});

$(document).on('hidden.bs.modal', '#countryselector-popup, #globalePopupWrapper', function () {
    var opener = $(this).data('opener');
    var scrollTop = $(this).data('scrollTop');
    var $modal = $(this);

    if (opener) {
        var $opener = $(opener);

        // Ensure modal and all related elements are completely hidden
        $modal.attr('aria-hidden', 'true').css('display', 'none');
        $('.modal-backdrop').attr('aria-hidden', 'true').remove();

        // Restore scroll position
        if (scrollTop !== undefined) {
            $(window).scrollTop(scrollTop);
        }

        // Prevent body from receiving focus (which causes "blank" announcement)
        var $body = $('body');
        var bodyTabIndex = $body.attr('tabindex');
        $body.attr('tabindex', '-1');

        // Temporarily remove landmark roles to prevent NVDA from announcing them
        var $header = $('header');
        var $nav = $('.header-navigation');
        var headerRole = $header.attr('role');
        var navAriaLabel = $nav.attr('aria-label');

        $header.attr('role', 'presentation');
        $nav.attr('role', 'presentation').removeAttr('aria-label');

        // Focus the button immediately to prevent focus from going to body
        $opener[0].focus({ preventScroll: true });

        // Restore everything after focus is established
        setTimeout(function () {
            // Restore body tabindex
            if (bodyTabIndex !== undefined) {
                $body.attr('tabindex', bodyTabIndex);
            } else {
                $body.removeAttr('tabindex');
            }

            // Restore header role
            if (headerRole) {
                $header.attr('role', headerRole);
            } else {
                $header.removeAttr('role');
            }

            // Restore nav role and aria-label
            $nav.removeAttr('role');
            if (navAriaLabel) {
                $nav.attr('aria-label', navAriaLabel);
            }
        }, 300);

        $(this).removeData('opener');
        $(this).removeData('scrollTop');
    }
});

function loadAccountHeaderMenu() {
    var $container = $('.user-section.d-flex');
    var url = $container.data('url');

    if (!$container.length || !url || $container.data('loaded')) {
        return;
    }

    $.ajax({
        url: url,
        method: 'GET',
        success: function (html) {
            $container.html(html);
            $container.data('loaded', true);
        }
    });
}

$(window).on('load', function () {
    if ('requestIdleCallback' in window) {
        requestIdleCallback(loadAccountHeaderMenu, { timeout: 500 });
        return;
    }

    setTimeout(loadAccountHeaderMenu, 0);
});

module.exports = {
    searchToggle: searchToggle,
    collapsibleHeader: collapsibleHeader,
    userToggle: userToggle,
    init: init
};
